import QueryKeyFactory from '../../../api/hooks/utils/queryKeyFactory'

export const contactKeys = new QueryKeyFactory('contact')
export const contactGroupKeys = new QueryKeyFactory(['contact', 'groups'])
export const richContactKeys = new QueryKeyFactory(['contact', 'rich'])
